import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Portfolio, ChoosenValue, ChangeAggregationConfig } from 'src/app/models';
import { Response } from '../models';

@Injectable({providedIn: 'root'})

export class PortfolioService {

  constructor(private http: HttpClient) { }

  getPortfolioConfiguration(idExecution: string): Promise<{ portfolio_items: Portfolio[] }> {
    return this.http.get<{ portfolio_items: Portfolio[] }>(`${environment.apiUrl}/GetPortfolioConfiguration`,
      {
        params: new HttpParams().set('id-execution', idExecution)
      }
    ).toPromise();
  }

  getAvailablePortfoliosForAggregation(idExecution: string): Promise<{ portfolio_items: { name_portfolio: string }[] }> {
    return this.http.get<{ portfolio_items: { name_portfolio: string }[] }>(`${environment.apiUrl}/GetAvailablePortfoliosForAggregation`,
      {
        params: new HttpParams().set('id-execution', idExecution)
      }
    ).toPromise();
  }

  createAggregationByPortfolios(idExecution: string, name: string, portfolioList: { name_portfolio: string }[]): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/CreateAggregationByPortfolios`,
      {
        id_execution: idExecution,
        name,
        portfolio_list: portfolioList
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  changeAggregationConfig(idExecution: string, name: string, idAggregation: string, idConfigurationItems: ChoosenValue[]): Promise<ChangeAggregationConfig> {
    return this.http.post<ChangeAggregationConfig>(`${environment.apiUrl}/ChangeAggregationConfig`,
      {
        id_execution: idExecution,
        name,
        id_aggregation: idAggregation,
        id_configuration_items: idConfigurationItems
      }
    ).toPromise();
  }

  executeAggregation(idExecution: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/ExecuteAggregation`,
      {
        id_execution: idExecution,
      }
    ).toPromise();
  }

  deleteAggregation(idExecution: string, idAggregation: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/DeleteAggregationByID`,
      {
        id_execution: idExecution,
        id_aggregation: idAggregation
      }
    ).toPromise();
  }
}
